import { sendClientRequest } from '@/utils/client-request'

export const searchProductsApi = (vendorId: string, query: string) =>
  sendClientRequest({
    url: `/products/search?q=${encodeURIComponent(query)}`,
    auth: false,
    headers: { Vendor: vendorId } as any,
  })
